export function CircularGauge({
	percentage,
	...props
}: {
	percentage: number
}) {
	const normalizedPercentage = Math.min(Math.max(percentage, 0), 100)
	const circumference = 2 * Math.PI * 42.5
	const strokePercent = (normalizedPercentage / 100) * circumference

	return (
		<svg
			data-slot='circular-gauge'
			aria-hidden='true'
			fill='none'
			height='16'
			width='16'
			strokeWidth='2'
			viewBox='0 0 100 100'
			className='size-3 -rotate-90'
			{...props}
		>
			<circle
				cx='50'
				cy='50'
				r='42.5'
				strokeWidth='12'
				strokeDashoffset='0'
				strokeLinecap='round'
				strokeLinejoin='round'
				className='opacity-20'
				stroke='currentColor'
				style={{
					strokeDasharray: `${circumference} ${circumference}`,
				}}
			/>
			<circle
				cx='50'
				cy='50'
				r='42.5'
				strokeWidth='12'
				strokeDashoffset='0'
				strokeLinecap='round'
				strokeLinejoin='round'
				stroke='currentColor'
				className='transition-all duration-300'
				style={{
					strokeDasharray: `${strokePercent} ${circumference}`,
				}}
			/>
		</svg>
	)
}
